"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserManagementModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const user_1 = require("../../../../service-lib/src/lib/entities/user");
const employee_entity_1 = require("../../../../service-lib/src/lib/entities/employee.entity");
const user_management_service_1 = require("./user-management.service");
const user_management_controller_1 = require("./user-management.controller");
const user_management_repository_1 = require("./user-management.repository");
const user_role_entity_1 = require("../../../../service-lib/src/lib/entities/user-role.entity");
let UserManagementModule = class UserManagementModule {
};
exports.UserManagementModule = UserManagementModule;
exports.UserManagementModule = UserManagementModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [typeorm_1.TypeOrmModule.forFeature([user_1.User, employee_entity_1.Employee, user_role_entity_1.UserRole])],
        providers: [user_management_service_1.UserManagementService, user_management_repository_1.UserManagementRepository],
        controllers: [user_management_controller_1.UserManagementController],
    })
], UserManagementModule);
